import { InjectionToken } from '@angular/core';
import { ResourceRegistrationToken } from '@bindoc-projects/resource-domain-lib';

export const RESOURCE_REGISTRATION =
  new InjectionToken<ResourceRegistrationToken>('RESOURCE_REGISTRATION');
